<template>
<div>
  <el-table
    class="subprogram-nba-standings-table"
    :data="teams"
    @row-click="onRowClick"
  >
    <!-- Team name -->
    <el-table-column
      :label="title"
      min-width="240"
      label-class-name="subprogram-nba-standings-table__label"
    >
      <template slot-scope="scope">
        <div
          class="subprogram-nba-standings-table__name"
          :class="{ 'subprogram-nba-standings-table__name--add-school': scope.row.schoolName }"
        >
          <div class="subprogram-nba-standings-table__name__pos">
            <span v-text="isConference ? scope.row.conference.position : scope.row.division.position" />
          </div>
          <div
            class="subprogram-nba-standings-table__name__icon"
            :style="{ backgroundImage: `url('${scope.row.imageUrl}')`}"
          />
          <span
            class="subprogram-nba-standings-table__name__team"
            v-text="scope.row.name"
          />
          <span
            class="subprogram-nba-standings-table__name__school"
            v-if="scope.row.schoolName"
            v-text="scope.row.schoolName"
          />
        </div>
      </template>
    </el-table-column>

    <!-- Standings -->
    <el-table-column
      v-for="({ label, value, minWidth}, index) in fields"
      :key="index"
      :label="label"
      :min-width="minWidth"
      align="center"
    >
      <template slot-scope="scope">
      <span v-text="value(scope.row)"></span>
    </template>
    </el-table-column>
  </el-table>
  </div>
</template>

<script>
import { get } from 'lodash';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-subprogram-nba-standings-table',
  props: {
    title: {
      type: String,
      required: true
    },
    teams: {
      type: Array,
      required: true,
    },
    onRowClick: {
      type: Function,
    },
    isConference: {
      type: Boolean
    },
  },
  computed: {},
  data() {
    return {
      fields: [
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.w',
          ),
          value: (team) => get(team, 'games.won.total', ''),
          minWidth: '50',
        },
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.l',
          ),
          value: (team) => get(team, 'games.lost.total', ''),
          minWidth: '50',
        },
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.win',
          ),
          value: (team) => {
            const played = get(team, 'games.played', 0);
            const totalWon = get(team, 'games.won.total', 0);
            const percentWin = Math.round(totalWon/played*100);
            return percentWin ? percentWin + ' % ' : ' - '
          },
          
          minWidth: '81',
        },
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.difference',
          ),
          value: (team) =>
            get(team, 'pointsFor', 0) -
            get(team, 'pointsAgainst', 0),
          minWidth: '100',
        },
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.home',
          ),
          value: (team) => `${get(team, 'games.won.home', '') + ' - ' +
            get(team, 'games.lost.home', '')}`,
          minWidth: '120',
        },
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.road',
          ),
          value: (team) => `${get(team, 'games.won.away', '') + ' - ' +
            get(team, 'games.lost.away', '')}`,
          minWidth: '130',
        },
        {
          label: i18n(
            'entities.subprogram.nba.team.standings.fields.last4',
          ),
          value: (team) => get(team, 'last4', ''),
          minWidth: '92',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.subprogram-nba-standings-table {
  border-radius: 2px;
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  background-color: #fff;
  margin-top: 16px;
  padding-bottom: 16px;
  &__name {
    display: grid;
    grid-template-areas: 'pos icon team';
    grid-template-columns: 16px 56px;
    align-items: center;

    &__pos {
      border-radius: 100%;
      background-color: rgba(42, 204, 204, 0.1);
      text-align: center;
      grid-area: pos;
      width: 20px;
      span {
        color: #2acccc;
        vertical-align: middle;
      }
    }
    &__icon {
      grid-area: icon;
      justify-self: center;
      width: 30px;
      height: 30px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    &__team {
      grid-area: team;
      text-transform: uppercase;
    }
    &__school {
      grid-area: school;
      font-size: 10px;
    }
    &--add-school {
      display: grid;
      grid-template-areas:
        'pos icon team'
        'pos icon school';
      grid-template-columns: 16px 56px;
      align-items: center;
      cursor: pointer;
    }
  }
}
</style>
<style>
.subprogram-nba-standings-table__label {
  text-transform: uppercase;
}
</style>